import React from 'react'
import PageHeader from '../common/page-header'
import PrivacyPolicyContent from './content'

const PrivacyPolicy = () => (
  <>
    <PageHeader title="Privacy Policy" />
    <PrivacyPolicyContent />
  </>
)
export default PrivacyPolicy
